import {
    DataGrid,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    makeStyles,
    shorthands,
    tokens,
    useTableColumnSizing_unstable,
    TableColumnSizingOptions,
    TableColumnDefinition,
    useTableFeatures,
    createTableColumn,
    TableCellLayout,
    Spinner
} from "@fluentui/react-components";
import {
    TextColumnOneWideLightningRegular,
    TextGrammarLightningRegular
} from "@fluentui/react-icons";
//import { IReportResultsGridProps } from "./report-results-grid.props";
import { ITableColumn } from "@interfaces/common.interfaces";
import { cloneElement, useContext, useEffect, useState } from "react";
import { format } from 'date-fns';
import ScreenPlaceholder from "components/common/screen-placeholder/screen-placeholder";
import { IScreenPlaceholderProps } from "components/common/screen-placeholder/screen-placeholder.props";
import Progress from "components/common/progress/progress";
import ReportProgress from "../report-progress/report-progress";
import { IReport } from "@interfaces/reports/reports-common.interfaces";
import { IReportResultsProps } from "./report-results.props";
import ReportResultsGrid from "../report-results-grid/report-results-grid";
import ReportResultsSummary from "../report-results-summary/report-results-summary";
import MessagesBar from "@components/common/messages-bar/messages-bar";
import { IMessagesBarProps } from "@components/common/messages-bar/messages-bar.props";
import ReportResultsMessageBar from "../report-results-message-bar/report-results-message-bar";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";


const layoutStyles = makeStyles({
    mainWrapper: {
        flexGrow: 1,
        ...shorthands.padding('0, 1em'),
        padding: '0 1em'
    },
    spinner: {
        margin: '2em 0'
    }
});

const defaultScreenPlaceHolderImage = "images/ReportPlaceholderImage.png";


export default function ReportResults<TI, TD>(props: IReportResultsProps<TI, TD>) {

    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const [report, setReport] = useState<IReport<TI, TD>>();

    const [showActionsMessage, setShowActionsMessage] = useState<boolean>(false);

    useEffect(() => {
        setReport(props.report);
    }, [props.report]);

    // Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
    // No index signature with a parameter of type 'string' was found on type 'unknown'.ts(7053)
    // (parameter) column: ITableColumn
    // ACTION: I needed to set item as any: props.items.map((item: any, idx) =>
    // TODO: Maybe remove the T here... and has the type on the interface as a type that has props on it??

    const initialisedScreenPlaceholderProps: IScreenPlaceholderProps = props.placeholder || {
        imageUrl: "images/ReportPlaceholderImage.png",
        title: t("ppaReportPlaceholderTitle"),
        message: t("ppaReportPlaceholderMessage")
    }

    const noItemsScreenPlaceholderProps: IScreenPlaceholderProps = props.placeholder || {
        imageUrl: "images/EmptyReportImage.png",
        title: t("ppaReportNoItemsTitle"),
        message: props.noItemsMessage || t("ppaReportNoItemsMessage")
    }

    //props.summaryComponent && cloneElement(props.summaryComponent, { report: report })

    return (
        <div className={styles.mainWrapper}>
            {props.loading &&
                <Spinner
                    className={styles.spinner}
                    labelPosition="below"
                    label={t('loading')} />}
            {!props.loading && !props.hasApiError &&
                <>
                    {props.requestStatus === -1 && !props.loading &&
                        <ScreenPlaceholder {...initialisedScreenPlaceholderProps} />}
                    {props.requestStatus > -1 && !report?.items &&
                        <ReportProgress status={props.requestStatus} percentageComplete={props.percentageComplete} />}
                    {props.requestStatus === 3 && report &&
                        <>
                            {props.view === 'summary' &&
                                <ReportResultsSummary
                                    report={report}
                                    summaryComponent={props.summaryComponent} />}
                            {props.view === 'items' &&
                                <ReportResultsGrid
                                    columns={props.columns}
                                    columnOptions={props.columnOptions}
                                    placeholder={noItemsScreenPlaceholderProps}
                                    report={report}
                                    noItemsMessage={props.noItemsMessage}
                                    selectionType={props.selectionType}
                                    onSelectionChanged={props.onSelectionChanged} />}
                        </>}
                </>}
        </div>
    );
}